import {
  faCheck,
  faClipboardList,
  faCog,
  faTimes,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { validationErrors } from "../constants/validationErrors";
/* eslint-disable */
export const STATUS_CODES = {
  SUBMITTED: 1,
  PROCESSING: 2,
  PROCESSED_NOT_PUBLISHED: 3,
  ERROR: 4,
  PUBLISHED_ON_CLINVAR: 5,
};
export const statusFilterOption = {
  Pending: [1, 2],
  Processed: [3, 5],
  Error: [4],
};
const statusInfo = {
  1: {
    label: "submitted",
    icon: faClipboardList,
    color: "tw-text-gray-600",
  },
  2: {
    label: "processing",
    icon: faCog,
    color: "tw-text-gray-600",
  },
  3: {
    label: "processed (not published)",
    icon: faCheckCircle,
    color: "tw-text-yellow-600",
  },
  4: {
    label: "error",
    icon: faTimes,
    color: "tw-text-red-600",
  },
  5: {
    label: "published",
    color: "tw-text-green-400",
    icon: faCheck,
  },
};

const requiredKeys = [
  "clinicalSignificance",
  "conditionSet",
  "condition",
  "clinicalSignificanceDescription",
  "observedIn",
  "variantSet",
  "variant",
  "assertionCriteria",
  "method",
  "releaseStatus",
  "recordStatus",
  "citation",
  "clinicalFeaturesAffectedStatus",
];

export const emptyStringValidation = (value) => {
  if (value === "") {
    return validationErrors.emptyStringError;
  }
  return ``;
};

export function dateValidation(dateString) {
  if (dateString === "") return;
  const datePattern = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
  if (!datePattern.test(dateString)) {
    return validationErrors.dateValidationError;
  }
  return ``;
}

export function urlValidation(url) {
  if (url === "") return;
  const urlRegex = /^https:\/\/[qd]\?submit\.ncbi\.nlm\.nih\.gov\/ft\/byid\/.*/;
  if (url.match(urlRegex) == null) {
    return validationErrors.urlValidationError;
  }
  return ``;
}

export function inputIsNumberValidation(input) {
  return isNaN(input) || Number(input) < 0
    ? validationErrors.numberValidationError
    : ``;
}

export function numericalValidation(number) {
  // Returns an error if the value is not a number OR not an integer OR less than 0
  if (
    isNaN(number) ||
    !Number.isInteger(Number(number)) ||
    Number(number) < 0
  ) {
    return validationErrors.numericalValidationError;
  }
  return ``;
}

export function clean(object) {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") {
      clean(v);
    }
    if (
      ((v && typeof v === "object" && !Object.keys(v).length) || v === "") &&
      !requiredKeys.includes(k)
    ) {
      if (Array.isArray(object)) {
        object.splice(k, 1);
      } else {
        delete object[k];
      }
    }
  });
  return object;
}

export const getErrors = (object) => {
  const arr = [];
  function checkErrors(object) {
    let errorFound = false;
    Object.entries(object).forEach(([key, value]) => {
      if (value && typeof value === "object") {
        errorFound = checkErrors(value);
      }
      if (value && typeof value !== "object" && value !== "") {
        errorFound = true;
        arr.push(errorFound);
      }
    });
    return arr;
  }
  const res = checkErrors(object);
  const isError = (value) => value === true;
  return res.some(isError);
};

export function getWrongFields(object) {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") {
      getWrongFields(v);
    }
    if (
      (v && typeof v === "object" && !Object.keys(v).length && v.length) ||
      v === false
    ) {
      object[k] = true;
    }
  });
  return object;
}

export const isJsonParsable = (string) => {
  try {
    JSON.parse(string);
  } catch (e) {
    return false;
  }
  return true;
};

export const formValidation = {
  recordStatus: emptyStringValidation,
  releaseStatus: emptyStringValidation,
  clinicalSignificance: {
    clinicalSignificanceDescription: emptyStringValidation,
    customAssertionScore: inputIsNumberValidation,
    dateLastEvaluated: dateValidation,
    citation: [
      {
        id: emptyStringValidation,
        url: emptyStringValidation,
        db: emptyStringValidation,
      },
    ],
  },
  variant: [
    {
      hgvs: emptyStringValidation,
      chromosomeCoordinates: {
        assembly: emptyStringValidation,
        chromosome: emptyStringValidation,
        start: numericalValidation,
        stop: numericalValidation,
      },
      gene: [
        {
          id: numericalValidation,
        },
      ],
    },
  ],
  assertionCriteria: {
    url: urlValidation,
    db: emptyStringValidation,
    id: emptyStringValidation,
  },
  conditionSet: {
    condition: [
      {
        name: emptyStringValidation,
        id: emptyStringValidation,
        db: emptyStringValidation,
      },
    ],
  },
  observedIn: [
    {
      affectedStatus: emptyStringValidation,
      alleleOrigin: emptyStringValidation,
      collectionMethod: emptyStringValidation,
      numberOfIndividuals: numericalValidation,
    },
  ],
};

export const getStatusInfo = (statusCode) => {
  const unknownStatusInfo = {
    label: "Not known status code",
    icon: null,
    color: null,
  };
  if (statusCode < 1 || statusCode > 5) return unknownStatusInfo;
  return statusInfo[statusCode];
};
